import moment from 'moment';
import {
    E_TIME_FILTER,
    E_TAB_FILTER,
    IActivitiesTab,
} from './ActivityPageInterfaces';
import { IBasicActivityRecord, INSIGHT_FEED_TYPE } from 'interfaces';
import _ from 'lodash';

export const PER_PAGE_LIMIT = 100;
export const downloadFromLink = (link: string) => {
    // @TODO: use https://github.com/eligrey/FileSaver.js/
    const downloadLink = document.createElement('a');
    downloadLink.href = link;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
};

export const getTimeFilterStartDate = (timeFilter: E_TIME_FILTER) => {
    switch (timeFilter) {
        case E_TIME_FILTER.MONTH:
            return moment()
                .subtract(1, 'month')
                .toISOString();
        case E_TIME_FILTER.WEEK:
            return moment()
                .subtract(1, 'week')
                .toISOString();
        case E_TIME_FILTER.ALL:
        default:
            return null;
    }
};
export const getItemId = (item: any): string | null =>
    _.toString(item?._id || item?.id);

export const getLastItemDate = (
    array: any,
    tab: E_TAB_FILTER
): string | null => {
    const item: any = _.last(array);
    if (tab === E_TAB_FILTER.PREDICTIONS) {
        return item?.call_date;
    }
    if (tab == E_TAB_FILTER.MY) {
        return item?.date;
    }
    return item?.shareDate;
};

export const getEmptyTabState = () => ({
    list: null,
    activeId: null,
    hasMore: true,
});
export const getInitialActivitiesTabsState = () => {
    const activitiesByTab: {
        [key in E_TAB_FILTER]: IActivitiesTab;
    } = {} as any;
    Object.values(E_TAB_FILTER).forEach(key => {
        activitiesByTab[key] = getEmptyTabState();
    });
    return activitiesByTab;
};

export const isPredictionId = (id: string | number) =>
    String(id).match(new RegExp(/^\d+$/));

export const getTabFromItem = (activity: any): E_TAB_FILTER => {
    const isPrediction = isPredictionId(getItemId(activity));
    if (isPrediction) return E_TAB_FILTER.PREDICTIONS;
    if (!(activity as IBasicActivityRecord).shared) return E_TAB_FILTER.MY;

    if (
        (activity as IBasicActivityRecord).feedTypes.includes(
            INSIGHT_FEED_TYPE.BMI
        )
    )
        return E_TAB_FILTER.BMI;
    return E_TAB_FILTER.GQ;
};

export const timeFilters = {
    [E_TIME_FILTER.WEEK]: 'Past Week',
    [E_TIME_FILTER.MONTH]: 'Past Month',
    [E_TIME_FILTER.ALL]: 'All Time',
};